import React from "react";
import { useNavigate } from "react-router-dom";
import "./Shipment.css";
import ChinaFlag from "../../assets/ChinaShipmentFlag.jpg";
import ThailandFlag from "../../assets/ThailandShipmentFlag.jpg";

const Shipment = () => {
  const navigate = useNavigate();

  return (
    <div className="shipment-container">
      <div className="shipment-text">
        Get your shipments <br />
        by <span>sea</span> and <span>air</span> <br />
        FCL & LCL cargo available
      </div>

      <div className="shipment-flag-block">
        <img src={ChinaFlag} alt="China Flag" className="shipment-flag" />
        <button
          className="shipment-button"
          onClick={() => navigate("/china")}
        >
          Products from China
        </button>
      </div>

      <div className="shipment-flag-block">
        <img src={ThailandFlag} alt="Thailand Flag" className="shipment-flag" />
        <button
          className="shipment-button"
          onClick={() => navigate("/thailand")}
        >
          Products from Thailand
        </button>
      </div>
    </div>
  );
};

export default Shipment;
